import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62a7f604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "confirm-modal modal-wrapper login-popup" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-7" }, "Are you sure you want to delete this item?", -1))
const _hoisted_3 = { class: "col-lg-12 p-0" }
const _hoisted_4 = { class: "action-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.isShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShow) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              class: "btn cancel-btn mr-3"
            }, "Cancel"),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-secondary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.removeItem && _ctx.removeItem(...args)), ["prevent"]))
            }, "Confirm")
          ])
        ]),
        _createElementVNode("button", {
          title: "Close (Esc)",
          type: "button",
          class: "mfp-close",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, "×")
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}